import GATSBY_COMPILED_MDX from "/home/jenkins/agent/workspace/site-verticals-deployment_master/packages/clearscore/apps/website/.cache/caches/gatsby-source-filesystem/4a76a8b1a2607566e536cd019c1c111a/learn-article-f70c40e1-c3eb-5f74-b79b-c791305f3d3a.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {getImage} from 'gatsby-plugin-image';
import Learn from '@clearscore/website.learn-article';
import Layout from '../components/layout';
const LearnTemplate = ({data, pageContext: {isWebView = false, localisations = []}, location, children}) => {
  const {learnArticle} = data;
  const {language, props, author, tags, hero, meta, publishedDate, formattedPublishDate, childMdx, authorImageNode, heroImageNode} = learnArticle;
  const timeToRead = childMdx?.timeToRead ?? 0;
  const wordCount = childMdx?.wordCount?.words ?? 0;
  const tableOfContents = childMdx?.tableOfContents ?? ({
    items: []
  });
  const authorImage = getImage(authorImageNode);
  const heroImage = getImage(heroImageNode);
  const authorProps = {
    ...author,
    ...author.language,
    image: authorImage,
    publishedDate,
    formattedPublishDate
  };
  const heroProps = {
    ...hero,
    image: heroImage
  };
  return React.createElement(Layout, {
    meta: {
      ...meta,
      image: heroImage?.images?.fallback?.src || ''
    },
    location: location.pathname,
    localisations: localisations,
    schemaMarkup: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': location.href ?? ''
      },
      articleSection: learnArticle.props.primaryCategory,
      headline: meta.title,
      description: meta.description,
      timeRequired: `PT${timeToRead}M`,
      image: heroImage?.images?.fallback?.src,
      author: {
        '@type': 'Person',
        name: author.name,
        jobTitle: author?.language?.title,
        image: authorImage?.images?.fallback?.src
      },
      publisher: {
        '@type': 'Organization',
        name: 'ClearScore',
        logo: {
          '@type': 'ImageObject',
          url: 'https://cdn-fs.clearscore.com/icons/@clearscore/rainbow.icons.clearscore/0.2.3/clearscore@3x.png',
          width: '96',
          height: '96'
        }
      },
      datePublished: new Date(Number(publishedDate)).toISOString()
    }
  }, ({commonModules}) => React.createElement(Learn, {
    isWebView: isWebView,
    language: {
      ...language,
      content: children
    },
    pageConfig: {
      ...props,
      timeToRead,
      wordCount,
      tableOfContents,
      tags
    },
    appStoreConfig: commonModules.app_store,
    author: authorProps,
    hero: heroProps
  }));
};
export const query = graphql`
    query LearnArticle($slug: String, $locale: String) {
        learnArticle(slug: { eq: $slug }, locale: { eq: $locale }) {
            childMdx {
                timeToRead
                wordCount {
                    words
                }
                tableOfContents
            }
            meta {
                description
                title
                url
            }
            publishedDate
            formattedPublishDate
            tags {
                name
                slug
            }
            language {
                title
                heading
                description
                ctaTitle
                ctaBlurb
                ctaButtonCopy
                keyHighlights
                keyHighlightsTitle
            }
            author {
                name
                language {
                    title
                    bio
                }
            }
            hero {
                name
                category
                language {
                    copyright
                    altText
                }
            }
            props {
                primaryCategory
                secondaryCategory
                primaryCategoryUrl
                displayDescription
                wordCount
                displayToc
                ctaUrl
            }
            heroImageNode {
                childImageSharp {
                    gatsbyImageData(quality: 90, breakpoints: [375, 768, 1024, 1200, 1440], layout: FULL_WIDTH)
                }
            }
            authorImageNode {
                childImageSharp {
                    gatsbyImageData(quality: 90, breakpoints: [375, 768, 1024, 1200, 1440], layout: FULL_WIDTH)
                }
            }
        }
    }
`;
LearnTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(LearnTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
